import { useIdentity } from '$api-clients/hooks';

/**
 * Get the license state for an agent by calling the team member endpoint directly.
 * The identity API handles resolving both legacy and identity IDs.
 * @param userId - The user id of the agent.
 * @param teamId - The team id of the agent.
 * @returns The license state of the agent.
 */
export function useAgentLicenseState(
  userId: string | null | undefined,
  teamId: string | null | undefined,
) {
  const { data, isLoading } = useIdentity(
    '/teams/{teamId}/members/{userId}',
    userId && teamId
      ? {
          params: { path: { userId, teamId } },
        }
      : null,
  );

  return {
    state: data?.license?.state ?? null,
    loading: isLoading,
  };
}
